<template>
  <div class="card card-competencias">
    <div class="card-header">
      <h4 class="card-title">Avaliações <loading-spin :check="loading"> </loading-spin></h4>
      <p class="category">Seguem abaixo as avaliações do colaborador até o momento: <br>  <div class="plano-acao"><i class="ti-arrow-circle-right text-warning"></i><small> <b style="color:#f0a810;padding-left:5px;">PA - PLANO DE AÇÃO</b></small></div> </p>
    </div>
    <div class="card-content">            
      <el-collapse>
        <el-collapse-item v-for="(evaluation, index) in evaluations" :title="`${evaluation.evaluation_cycle_name} - ${evaluation.evaluation_type_name} | ${evaluation.evaluation_label_status.name}`" :name="evaluation.id" :key="index">
          <div v-if="evaluation.evaluation_type_id == 1">
            <div class="row" v-if="evaluation.status">
              <div class="col-lg-12 col-sm-12"> 
                <b>Segue abaixo o resultado da avaliação:</b> <br/><br/>
              </div>
              <div class="col-lg-12 col-sm-12">
                <circle-chart-card :percentage="evaluation.total_percent"
                                    title="RESULTADO FINAL"
                                    :description="evaluation.evaluation_type_name"
                                    :color="percentTotalColor(evaluation.total_percent)">
                </circle-chart-card>
              </div>
              <div class="col-lg-12 col-sm-12 text-center" v-if="evaluation.is_plan"> 
                <button @click="openOverview(evaluation.id)" class="btn btn-info btn-fill btn-wd">Visão Geral</button>
              </div>
              <div class="col-lg-12 col-sm-12 text-center" v-else> 
                <button @click="openSetPlan(evaluation.id)" class="btn btn-success btn-fill btn-wd">
                  <span class="btn-label"><i class="ti-target"></i></span>
                  Informar o plano de ação
                </button>
                <button class="btn btn-wd btn-warning btn-fill" @click="evaluationEdit(evaluation.id)">
                  <span class="btn-label"><i class="ti-pencil-alt"></i></span>
                  Editar Avaliação
                </button>
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-md-12 text-center">
                <button @click="toEvaluate(evaluation)" class="btn btn-fill btn-success btn-wd">
                  <i class="ti-check"></i> AVALIAR
                </button>
              </div>
            </div>
          </div>          
          <div v-if="evaluation.evaluation_type_id == 3">
            <div class="row" v-if="evaluation.status">
              <div class="col-lg-12 col-sm-12"> 
                <b>Segue abaixo o resultado da autoavaliação:</b> <br/><br/>
              </div>
              <div class="col-lg-12 col-sm-12">
                <circle-chart-card :percentage="evaluation.total_percent"
                                    title="RESULTADO FINAL"
                                    :description="evaluation.evaluation_type_name"
                                    :color="percentTotalColor(evaluation.total_percent)">
                </circle-chart-card>
              </div>
              <div class="col-lg-12 col-sm-12 text-center"> 
                <button @click="openOverview(evaluation.id)" class="btn btn-info btn-fill btn-wd">Visão Geral</button>
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-md-12 text-center">
                <div class="col-lg-12 col-sm-12"> 
                  <b>Aguardando realização da autoavaliação</b>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import swal from 'sweetalert2'
  import {Collapse, CollapseItem} from 'element-ui'
  import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
  import VueTabs from 'vue-nav-tabs'

  Vue.use(VueTabs)
  Vue.use(Collapse)
  Vue.use(CollapseItem)
  export default {
    props: {
      collaboratorId: [Number]
    },
    data () {
      return {
        evaluations: [],
        loading: false
      }
    },
    components: {
      CircleChartCard
    },
    methods: {
      async getEvaluations () {
        let url = `/collaborator/manager/collaborator/${this.collaboratorId}/evaluations`
        this.loading = true
        await axios.get(url)
        .then((response) => {
          this.evaluations = response.data
        }).catch((error) => {
          console.log(error)
        })
        this.loading = false
      },
      toEvaluate (evaluation) {
        const evaluationId = evaluation.id
        swal({
          title: 'Você tem certeza!',
          text: 'Você iniciará avaliação agora.',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'OK',
          buttonsStyling: false,
          preConfirm: res => {
            return this.verifyAccess(evaluationId).catch(error => {
              let message =
                'Não foi possível completar a requisição, tente novamente mais tarde.'
              if (error.response.status !== 500) {
                message = error.response.data.error
              }

              swal.showValidationError(message)

              return new Promise((resolve, reject) => {
                reject(new Error(message))
              })
            })
          }
        }).then(res => {
          this.execEvaluation(evaluationId, res.data)
        })
      },
      verifyAccess (evaluationId) {
        return axios.post('/collaborator/manager/verify-access-evaluation', {
          evaluation_id: evaluationId
        })
      },
      execEvaluation (evaluationId, dataAccess) {
        swal({
          title: 'Acesso Liberado!',
          html: 'Link de validação gerado. <br/> <small>Você tem 72 horas para realizar avaliação com o link gerado.</small>',
          type: 'success',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Acessar Avaliação',
          buttonsStyling: false,
          preConfirm: () => {
            if (dataAccess.access_token) {
              return new Promise((resolve, reject) => {
                resolve(dataAccess)
              })
            }

            return new Promise((resolve, reject) => {
              reject(new Error('Token não pode ser encontrado.'))
            })
          }
        })
        .then(res => {
          this.$router.push(`/avaliacao/formulario/${this.collaboratorId}/${evaluationId}/${res.access_token}`)
        })
        .catch(swal.noop)
      },
      openOverview (evaluationId) {
        this.$router.push(`/avaliacao/equipe/perfil/${this.collaboratorId}/resultado-completo/${evaluationId}`)
      },
      openSetPlan (evaluationId) {
        this.$router.push(`/avaliacao/formulario-resultado/${evaluationId}/${this.collaboratorId}`)
      },
      percentColor (percent) {
        let classColor = 'success'

        if (percent >= 0 && percent < 40) {
          classColor = 'danger'
        } else if (percent >= 40 && percent < 80) {
          classColor = 'warning'
        }
        return classColor
      },
      percentTotalColor (percent) {
        let color = 'green'

        if (percent >= 0 && percent < 40) {
          color = 'red'
        }

        if (percent >= 40 && percent < 80) {
          color = 'orange'
        }

        return color
      },
      evaluationEdit (evaluationId) {
        this.$router.push(`/avaliacao/formulario-editar/${evaluationId}/${this.collaboratorId}`)
      }
    },
    watch: {
      collaboratorId () {
        this.getEvaluations()
      }
    }
  }
</script>
<style>
  .el-collapse-item__header {
    line-height: 18px;
  }

  .plano-acao {
    margin-top:0px;
  }

  .plano-acao i {
    margin-top:10px;
    vertical-align: middle;
  }

  .el-collapse-item__header {
    line-height:normal !important;
  }

  .btn-fill {
    margin:10px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Manager/Evaluation/Team/CollaboratorProfile/EvaluationCard.vue